export type PageItem = number | '…';

// Les numéros de page à afficher : toujours la première et la dernière, la page courante et ses voisines.
export const pageWindow = (
  page: number,
  pageCount: number,
  neighbours = 1,
): PageItem[] => {
  const wanted = new Set(
    [
      1,
      pageCount,
      ...Array.from(
        { length: neighbours * 2 + 1 },
        (_, i) => page - neighbours + i,
      ),
    ].filter((n) => n >= 1 && n <= pageCount),
  );
  const sorted = [...wanted].sort((a, b) => a - b);

  return sorted.flatMap((n, index): PageItem[] => {
    const previous = sorted[index - 1];
    if (previous === undefined || n - previous === 1) return [n];
    // Une seule page manquante s'écrit plutôt que d'être masquée par des points.
    return n - previous === 2 ? [previous + 1, n] : ['…', n];
  });
};
